import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 400,
    boxShadow: theme.shadows[2],
    borderRadius: theme.spacing(0.5),
    position: 'fixed',
    right: theme.spacing(5),
    zIndex: theme.zIndex.drawer,

    '& .MuiButton-root': {
      margin: theme.spacing(1.75, 'auto', 0, 0),
    },
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1.5),
    color: theme.palette.warning.darkest,
  },
  alertTitle: {
    marginBottom: theme.spacing(0.5),
  },
  downloadButton: {
    height: 26,
    margin: theme.spacing(1.75, 'auto', 0, 0),
    padding: theme.spacing(0, 1),

    '& .MuiTypography-h4': {
      marginBottom: 0,
    },
  },
}))

export default useStyles
